module.exports = __webpack_public_path__ + "media/images/bg/headers/origami-f60a2ea89497e943949ab36fd20fb631.png";